const Experience = () => {
    return (
        <div className="experience">
            <h2>Experience</h2>

            <ul>
                <li>
                    <i>PES College of Engineering, Aurangabad</i>, 2019-2023
                    <ul>
                        <li>Current CGPA - 8.1</li>
                    </ul>
                </li>
                <li>
                    <i>Nullclass</i> - <strong>Front-end Developer Intern</strong>, 2022
                    <ul>
                        <li>worked on fullstack applications to enhance funtionality and user experience.</li>
                        <li>Tech stack: Javascript, React.js</li>
                    </ul>
                </li>
                {/* <li>
                    <i>SpiderChain</i> - <strong>Blockchain Developer</strong>, 2019-2022
                    <ul>
                        <li>Contributed to smart contract development on client's platform</li>
                        <li>Peer reviewed &amp; Audited Solidity code</li>
                    </ul>
                </li> */} 
            </ul>
            <br />
            <h2>Achievements</h2>
            <ul>
                <li>Got selected in HyperEdge Winter of Blockchain'2023 open-source contribution Program. </li>
                <li>Open-source Contributor at Timechain summer of code (TSSoC'23) . </li>
                <li>Open-source Contributor at Social summer of code (SSoC'23) . </li>
                <li>Solved 300+ problems on LeetCode</li>
                <li>Got 2387th Rank in Google Hashcode 2022</li>
                <li>Got selected for TezIndia BuilderCamp 1.0 across india</li>
                <li>Runner up in Solana india dev. challenge 2022</li>
            </ul>
        </div>
    );
}

export default Experience;